export default __webpack_public_path__ + "static/media/trash.712733b1.svg";